import { LogisticsTip, TipRarity } from '../types';

export const logisticsTips: LogisticsTip[] = [
  // COMMON TIPS (50%)
  {
    id: 1,
    title: "Optimización de rutas de entrega",
    description: "Utiliza software de planificación de rutas para reducir distancias y tiempos de entrega. Puedes ahorrar hasta un 30% en costos de combustible.",
    imageUrl: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 2,
    title: "Mantenimiento preventivo de vehículos",
    description: "Implementa un programa de mantenimiento preventivo para tu flota. Reduce averías inesperadas y prolonga la vida útil de los vehículos.",
    imageUrl: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 3,
    title: "Capacitación continua de conductores",
    description: "Invierte en la formación regular de tus conductores. Conductores bien entrenados consumen menos combustible y tienen menos accidentes.",
    imageUrl: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 4,
    title: "Optimización de carga",
    description: "Maximiza el espacio de carga en cada viaje. Una carga bien planificada reduce el número de viajes necesarios y los costos asociados.",
    imageUrl: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 5,
    title: "Monitoreo de presión de neumáticos",
    description: "Verifica regularmente la presión de los neumáticos. La presión correcta mejora el rendimiento del combustible y reduce el desgaste.",
    imageUrl: "https://images.unsplash.com/photo-1578844251758-2f71da64c96f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 6,
    title: "Documentación digital",
    description: "Digitaliza toda la documentación de transporte. Reduce errores, facilita búsquedas y ahorra tiempo en trámites administrativos.",
    imageUrl: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 7,
    title: "Comunicación efectiva con clientes",
    description: "Mantén informados a tus clientes sobre el estado de sus envíos. La transparencia mejora la satisfacción y reduce consultas innecesarias.",
    imageUrl: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 8,
    title: "Planificación de cargas de retorno",
    description: "Busca cargas para los viajes de retorno. Evita que tus vehículos regresen vacíos y maximiza la rentabilidad de cada ruta.",
    imageUrl: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 9,
    title: "Análisis de costos por kilómetro",
    description: "Calcula y monitorea el costo por kilómetro de tu operación. Este indicador te ayuda a identificar ineficiencias y oportunidades de mejora.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 10,
    title: "Gestión eficiente de combustible",
    description: "Implementa un sistema de control de combustible. Detecta consumos anormales y previene posibles fugas o robos.",
    imageUrl: "https://images.unsplash.com/photo-1545459720-aac8509eb02c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 11,
    title: "Estandarización de procesos",
    description: "Documenta y estandariza todos los procesos operativos. Reduce variabilidad, errores y facilita la capacitación de nuevo personal.",
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 12,
    title: "Revisión periódica de seguros",
    description: "Evalúa regularmente tus pólizas de seguro. Asegúrate de tener la cobertura adecuada sin pagar por protecciones innecesarias.",
    imageUrl: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 13,
    title: "Planificación de horarios de entrega",
    description: "Programa entregas fuera de horas pico. Reduce tiempos de tránsito y mejora la puntualidad en zonas urbanas congestionadas.",
    imageUrl: "https://images.unsplash.com/photo-1484807352052-23338990c6c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 14,
    title: "Capacitación en seguridad vial",
    description: "Implementa programas regulares de seguridad vial. Reduce accidentes, costos de reparación y primas de seguro.",
    imageUrl: "https://images.unsplash.com/photo-1464219789935-c2d9d9aba644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 15,
    title: "Gestión de tiempos de espera",
    description: "Minimiza los tiempos de espera en carga y descarga. Coordina horarios con clientes y optimiza la utilización de tu flota.",
    imageUrl: "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 16,
    title: "Análisis de rendimiento de conductores",
    description: "Evalúa regularmente el desempeño de tus conductores. Identifica buenas prácticas y áreas de mejora en consumo y seguridad.",
    imageUrl: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 17,
    title: "Optimización de inventario de repuestos",
    description: "Mantén un inventario óptimo de repuestos críticos. Reduce tiempos de inactividad por espera de piezas sin exceder en inventario.",
    imageUrl: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 18,
    title: "Revisión de contratos con proveedores",
    description: "Negocia regularmente con proveedores de servicios y suministros. Obtén mejores condiciones y descuentos por volumen.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-1696413565d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 19,
    title: "Planificación de reemplazo de flota",
    description: "Desarrolla un plan de renovación de flota a largo plazo. Evita costos excesivos de mantenimiento en vehículos antiguos.",
    imageUrl: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 20,
    title: "Gestión de documentos regulatorios",
    description: "Mantén un sistema organizado para documentos regulatorios. Evita multas y retrasos por documentación incompleta o vencida.",
    imageUrl: "https://images.unsplash.com/photo-1568290696106-ace1d12003cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 21,
    title: "Capacitación en carga y descarga",
    description: "Entrena a tu personal en técnicas eficientes de carga y descarga. Reduce tiempos de operación y riesgos de daños a la mercancía.",
    imageUrl: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 22,
    title: "Análisis de rutas alternativas",
    description: "Evalúa regularmente rutas alternativas para tus destinos frecuentes. Las condiciones viales cambian y pueden surgir opciones más eficientes.",
    imageUrl: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 23,
    title: "Gestión de residuos operativos",
    description: "Implementa un programa de gestión de residuos en tu operación. Reduce costos de disposición y mejora tu impacto ambiental.",
    imageUrl: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 24,
    title: "Comunicación efectiva entre departamentos",
    description: "Mejora la comunicación entre ventas, operaciones y administración. Evita malentendidos y optimiza la coordinación interna.",
    imageUrl: "https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 25,
    title: "Análisis de satisfacción del cliente",
    description: "Realiza encuestas regulares de satisfacción. Identifica áreas de mejora y fortalece relaciones con clientes clave.",
    imageUrl: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 26,
    title: "Optimización de embalajes",
    description: "Revisa y mejora tus métodos de embalaje. Reduce daños en mercancía y optimiza espacio de carga sin comprometer seguridad.",
    imageUrl: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 27,
    title: "Gestión de multas y infracciones",
    description: "Implementa un sistema de seguimiento de infracciones. Identifica patrones y conductores problemáticos para acciones correctivas.",
    imageUrl: "https://images.unsplash.com/photo-1464219789935-c2d9d9aba644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 28,
    title: "Planificación de mantenimiento en temporada baja",
    description: "Programa mantenimientos mayores durante periodos de baja demanda. Maximiza disponibilidad de flota cuando más se necesita.",
    imageUrl: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 29,
    title: "Gestión de devoluciones",
    description: "Optimiza tu proceso de manejo de devoluciones. Un sistema eficiente reduce costos y mejora la satisfacción del cliente.",
    imageUrl: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 30,
    title: "Análisis de costos fijos vs variables",
    description: "Revisa regularmente la proporción de costos fijos y variables. Ajusta tu estructura para mayor flexibilidad ante cambios de demanda.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 31,
    title: "Capacitación en eficiencia energética",
    description: "Entrena a conductores en técnicas de conducción eficiente. Reduce consumo de combustible y emisiones sin afectar tiempos de entrega.",
    imageUrl: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 32,
    title: "Gestión de documentación aduanera",
    description: "Mantén actualizada toda la documentación para cruces fronterizos. Evita retrasos y costos adicionales en operaciones internacionales.",
    imageUrl: "https://images.unsplash.com/photo-1568290696106-ace1d12003cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 33,
    title: "Análisis de tiempos de carga/descarga",
    description: "Mide y optimiza tiempos en muelles de carga. Pequeñas mejoras en estos procesos generan grandes ahorros a largo plazo.",
    imageUrl: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 34,
    title: "Revisión de políticas de viáticos",
    description: "Evalúa y actualiza tus políticas de viáticos para conductores. Equilibra control de gastos con condiciones justas para el personal.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-1696413565d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 35,
    title: "Gestión de neumáticos usados",
    description: "Implementa un programa de reciclaje de neumáticos. Reduce costos de disposición y mejora tu huella ambiental.",
    imageUrl: "https://images.unsplash.com/photo-1578844251758-2f71da64c96f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 36,
    title: "Análisis de rentabilidad por cliente",
    description: "Evalúa la rentabilidad de cada cliente regularmente. Identifica relaciones que requieren renegociación o terminación.",
    imageUrl: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 37,
    title: "Gestión de espacios de almacenamiento",
    description: "Optimiza la distribución de tu almacén o patio. Mejora flujos de trabajo y reduce tiempos de búsqueda y movimiento.",
    imageUrl: "https://images.unsplash.com/photo-1553413077-190dd305871c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 38,
    title: "Planificación de rutas estacionales",
    description: "Ajusta tus rutas según patrones estacionales. Considera cambios en clima, tráfico turístico y demanda de productos.",
    imageUrl: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 39,
    title: "Gestión de tiempos de descanso",
    description: "Asegura cumplimiento de tiempos de descanso obligatorios. Evita multas y reduce riesgos de accidentes por fatiga.",
    imageUrl: "https://images.unsplash.com/photo-1464219789935-c2d9d9aba644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 40,
    title: "Análisis de costos ocultos",
    description: "Identifica y cuantifica costos ocultos en tu operación. Pequeños gastos recurrentes pueden sumar montos significativos anualmente.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 41,
    title: "Gestión de combustible en ralentí",
    description: "Reduce tiempos de motor en ralentí. Un camión consume aproximadamente 2-3 litros por hora en ralentí sin producir trabajo útil.",
    imageUrl: "https://images.unsplash.com/photo-1545459720-aac8509eb02c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 42,
    title: "Capacitación en primeros auxilios",
    description: "Entrena a conductores en primeros auxilios básicos. Puede marcar la diferencia en caso de accidentes en rutas remotas.",
    imageUrl: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 43,
    title: "Análisis de rutas de alto riesgo",
    description: "Identifica y evalúa rutas con mayor incidencia de robos o accidentes. Implementa medidas preventivas específicas.",
    imageUrl: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 44,
    title: "Gestión de lubricantes y filtros",
    description: "Optimiza intervalos de cambio de aceite y filtros. Equilibra costos de mantenimiento con protección del motor.",
    imageUrl: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 45,
    title: "Planificación de cargas por peso y volumen",
    description: "Optimiza la distribución de carga considerando peso y volumen. Evita sobrecostos por desaprovechamiento de capacidad.",
    imageUrl: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 46,
    title: "Gestión de equipos de amarre y sujeción",
    description: "Mantén inventario y control de equipos de sujeción de carga. Asegura disponibilidad y buen estado para evitar daños y retrasos.",
    imageUrl: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 47,
    title: "Análisis de costos por cliente y ruta",
    description: "Calcula costos específicos por cliente y ruta. Identifica operaciones deficitarias que requieren ajustes de tarifa.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 48,
    title: "Gestión de uniformes y equipo de seguridad",
    description: "Implementa un sistema de control para uniformes y equipo de protección. Asegura disponibilidad y cumplimiento de normativas.",
    imageUrl: "https://images.unsplash.com/photo-1464219789935-c2d9d9aba644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 49,
    title: "Capacitación en manejo defensivo",
    description: "Implementa programas de conducción defensiva para tu equipo. Reduce accidentes y costos asociados significativamente.",
    imageUrl: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  {
    id: 50,
    title: "Análisis de proveedores alternativos",
    description: "Evalúa regularmente proveedores alternativos para insumos clave. Mantén opciones disponibles para emergencias y negociaciones.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-1696413565d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.COMMON
  },
  
  // UNCOMMON TIPS (25%)
  {
    id: 51,
    title: "Implementación de telemetría avanzada",
    description: "Instala sistemas de telemetría en toda tu flota. Monitorea en tiempo real consumo, conducción y estado mecánico para optimizar operaciones.",
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 52,
    title: "Análisis predictivo de mantenimiento",
    description: "Utiliza análisis de datos para predecir fallas mecánicas. Interviene antes de averías costosas basándote en patrones de rendimiento.",
    imageUrl: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 53,
    title: "Optimización de cross-docking",
    description: "Implementa operaciones de cross-docking para reducir almacenamiento. Transfiere mercancía directamente entre vehículos minimizando tiempos de espera.",
    imageUrl: "https://images.unsplash.com/photo-1553413077-190dd305871c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 54,
    title: "Gestión dinámica de rutas",
    description: "Implementa sistemas de ruteo dinámico en tiempo real. Ajusta rutas según condiciones de tráfico, clima y nuevos pedidos durante la jornada.",
    imageUrl: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 55,
    title: "Programas de incentivos para conductores",
    description: "Diseña programas de incentivos basados en métricas clave. Premia eficiencia en combustible, seguridad y puntualidad para mejorar desempeño.",
    imageUrl: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 56,
    title: "Análisis de huella de carbono",
    description: "Calcula y monitorea la huella de carbono de tu operación. Identifica oportunidades de reducción y prepárate para futuras regulaciones.",
    imageUrl: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 57,
    title: "Implementación de backhauls planificados",
    description: "Desarrolla una estrategia sistemática de backhauls. Coordina con clientes y proveedores para maximizar cargas de retorno.",
    imageUrl: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 58,
    title: "Gestión de fatiga de conductores",
    description: "Implementa un programa de gestión de fatiga basado en ciencia. Monitorea patrones de sueño y alertas para prevenir accidentes.",
    imageUrl: "https://images.unsplash.com/photo-1464219789935-c2d9d9aba644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 59,
    title: "Optimización de flotas heterogéneas",
    description: "Desarrolla algoritmos para asignación óptima en flotas mixtas. Asigna el vehículo ideal para cada carga según características específicas.",
    imageUrl: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 60,
    title: "Análisis avanzado de costos operativos",
    description: "Implementa un sistema de costeo basado en actividades (ABC). Identifica con precisión los costos reales de cada componente de servicio.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 61,
    title: "Gestión de neumáticos por presión y temperatura",
    description: "Instala sistemas de monitoreo de presión y temperatura. Detecta problemas en tiempo real y extiende la vida útil de los neumáticos.",
    imageUrl: "https://images.unsplash.com/photo-1578844251758-2f71da64c96f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 62,
    title: "Implementación de KPIs avanzados",
    description: "Desarrolla indicadores clave de desempeño específicos para transporte. Mide y mejora aspectos críticos más allá de los básicos.",
    imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 63,
    title: "Análisis de escenarios para planificación estratégica",
    description: "Utiliza modelado de escenarios para decisiones estratégicas. Evalúa impactos potenciales de cambios en combustible, regulaciones o mercado.",
    imageUrl: "https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 64,
    title: "Gestión de flotas con vehículos alternativos",
    description: "Integra vehículos eléctricos o de gas natural en rutas apropiadas. Reduce costos operativos y emisiones en distancias cortas o medias.",
    imageUrl: "https://images.unsplash.com/photo-1593941707882-a5bba53b0998?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 65,
    title: "Implementación de sistemas avanzados de seguridad",
    description: "Instala tecnologías ADAS en tu flota. Sistemas como frenado automático y alerta de carril reducen significativamente accidentes.",
    imageUrl: "https://images.unsplash.com/photo-1464219789935-c2d9d9aba644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 66,
    title: "Análisis de big data para optimización logística",
    description: "Utiliza análisis de grandes volúmenes de datos operativos. Identifica patrones ocultos y oportunidades de mejora no evidentes.",
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 67,
    title: "Gestión de cadena de frío con IoT",
    description: "Implementa sensores IoT para monitoreo de temperatura en tiempo real. Garantiza integridad de productos sensibles y documenta cumplimiento.",
    imageUrl: "https://images.unsplash.com/photo-1580674285054-bed31e145f59?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 68,
    title: "Implementación de sistemas de gestión de almacenes (WMS)",
    description: "Integra WMS con tu operación de transporte. Optimiza preparación de pedidos y reduce tiempos de espera en carga.",
    imageUrl: "https://images.unsplash.com/photo-1553413077-190dd305871c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 69,
    title: "Análisis de rentabilidad por segmento",
    description: "Segmenta tu operación por tipo de carga, distancia y cliente. Identifica nichos más rentables para enfocar esfuerzos comerciales.",
    imageUrl: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 70,
    title: "Gestión de riesgos en cadena de suministro",
    description: "Desarrolla un programa formal de gestión de riesgos. Identifica vulnerabilidades y prepara planes de contingencia para disrupciones.",
    imageUrl: "https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 71,
    title: "Implementación de sistemas de visibilidad end-to-end",
    description: "Ofrece visibilidad completa de la cadena a clientes. Diferénciate con transparencia total desde origen hasta destino final.",
    imageUrl: "https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 72,
    title: "Análisis de costo total de propiedad (TCO)",
    description: "Calcula el TCO completo para decisiones de flota. Considera todos los costos del ciclo de vida, no solo precio de adquisición.",
    imageUrl: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 73,
    title: "Gestión de combustible con tarjetas inteligentes",
    description: "Implementa sistema de tarjetas inteligentes para combustible. Controla con precisión consumos y detecta anomalías inmediatamente.",
    imageUrl: "https://images.unsplash.com/photo-1545459720-aac8509eb02c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 74,
    title: "Implementación de sistemas de reconocimiento de fatiga",
    description: "Instala tecnología de detección de fatiga en cabinas. Alerta a conductores cuando muestran signos de somnolencia para prevenir accidentes.",
    imageUrl: "https://images.unsplash.com/photo-1464219789935-c2d9d9aba644?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  {
    id: 75,
    title: "Análisis de densidad de valor en cargas",
    description: "Evalúa la densidad de valor de diferentes tipos de carga. Prioriza mercancías de alto valor y bajo volumen para maximizar rentabilidad.",
    imageUrl: "https://images.unsplash.com/photo-1553413077-190dd305871c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.UNCOMMON
  },
  
  // RARE TIPS (15%)
  {
    id: 76,
    title: "Implementación de blockchain en logística",
    description: "Utiliza blockchain para crear registros inmutables de la cadena de suministro. Esta tecnología mejora la trazabilidad y reduce disputas sobre entregas y condiciones.",
    imageUrl: "https://images.unsplash.com/photo-1639762681057-408e52192e55?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 77,
    title: "Gemelos digitales para simulación logística",
    description: "Crea gemelos digitales de tu red logística para simulaciones avanzadas. Estos modelos virtuales permiten probar cambios sin riesgos operativos reales.",
    imageUrl: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 78,
    title: "Optimización de rutas con algoritmos genéticos",
    description: "Implementa algoritmos genéticos para problemas complejos de ruteo. Estos algoritmos pueden encontrar soluciones óptimas en escenarios con múltiples restricciones.",
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 79,
    title: "Logística predictiva con machine learning",
    description: "Utiliza machine learning para predecir demanda y optimizar recursos. Los modelos predictivos pueden reducir inventarios hasta un 30% manteniendo niveles de servicio.",
    imageUrl: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 80,
    title: "Gestión de flotas con vehículos autónomos",
    description: "Prepara tu operación para integrar vehículos autónomos. Esta tecnología promete reducir costos de personal y mejorar la seguridad en el transporte.",
    imageUrl: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 81,
    title: "Análisis de big data en tiempo real",
    description: "Implementa análisis de big data en tiempo real para decisiones operativas. Procesar grandes volúmenes de datos permite identificar patrones y anomalías instantáneamente.",
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 82,
    title: "Gestión de cadena de frío con IoT avanzado",
    description: "Utiliza sensores IoT avanzados para monitoreo de cadena de frío. Estos sistemas permiten control preciso de temperatura y alertas predictivas de fallos.",
    imageUrl: "https://images.unsplash.com/photo-1580674285054-bed31e145f59?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 83,
    title: "Planificación de red con optimización estocástica",
    description: "Implementa modelos de optimización estocástica para diseño de redes. Estos modelos consideran incertidumbre en demanda y costos para diseño de redes. Estos modelos consideran incertidumbre en demanda y costos para diseños más robustos.",
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 84,
    title: "Gestión de inventario con drones en almacenes",
    description: "Utiliza drones para inventarios automáticos en almacenes. Esta tecnología puede reducir tiempos de inventario hasta un 90% con mayor precisión.",
    imageUrl: "https://images.unsplash.com/photo-1553413077-190dd305871c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 85,
    title: "Análisis de sentimiento en feedback de clientes",
    description: "Implementa análisis de sentimiento en comentarios de clientes. Esta tecnología identifica problemas emergentes antes de que afecten significativamente tu operación.",
    imageUrl: "https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 86,
    title: "Gestión de flotas con combustibles alternativos",
    description: "Implementa una estrategia de transición a combustibles alternativos. Vehículos eléctricos o de hidrógeno pueden reducir costos operativos a largo plazo.",
    imageUrl: "https://images.unsplash.com/photo-1593941707882-a5bba53b0998?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 87,
    title: "Planificación de escenarios con simulación Monte Carlo",
    description: "Utiliza simulación Monte Carlo para evaluar riesgos en la cadena de suministro. Esta técnica permite cuantificar probabilidades de diferentes escenarios.",
    imageUrl: "https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 88,
    title: "Gestión de almacenes con robots colaborativos",
    description: "Implementa robots colaborativos en operaciones de almacén. Estos robots trabajan junto a humanos aumentando productividad sin requerir cambios de infraestructura.",
    imageUrl: "https://images.unsplash.com/photo-1563770660941-20978e870e26?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 89,
    title: "Análisis de video para seguridad de carga",
    description: "Utiliza análisis de video con IA para monitorear seguridad de carga. Esta tecnología detecta automáticamente manipulaciones sospechosas o condiciones inseguras.",
    imageUrl: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  {
    id: 90,
    title: "Gestión de última milla con microhubs urbanos",
    description: "Implementa microhubs urbanos para entregas de última milla. Esta estrategia reduce costos y emisiones en entregas urbanas utilizando vehículos pequeños o bicicletas.",
    imageUrl: "https://images.unsplash.com/photo-1573648828266-64cf63bba7e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.RARE
  },
  
  // EPIC TIPS (7%)
  {
    id: 91,
    title: "Logística autónoma con IA avanzada",
    description: "Implementa sistemas de decisión autónomos basados en IA. Estos sistemas pueden optimizar operaciones completas con mínima intervención humana, adaptándose a cambios en tiempo real.",
    imageUrl: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.EPIC
  },
  {
    id: 92,
    title: "Cadenas de suministro circulares",
    description: "Rediseña tu operación hacia un modelo de cadena de suministro circular. Este enfoque integra logística inversa y reutilización de materiales desde el diseño, reduciendo costos y impacto ambiental.",
    imageUrl: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.EPIC
  },
  {
    id: 93,
    title: "Gemelos digitales con simulación en tiempo real",
    description: "Implementa gemelos digitales con capacidad de simulación en tiempo real. Esta tecnología permite evaluar instantáneamente el impacto de disrupciones y optimizar respuestas.",
    imageUrl: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.EPIC
  },
  {
    id: 94,
    title: "Logística predictiva con aprendizaje profundo",
    description: "Utiliza redes neuronales profundas para predicciones logísticas ultraavanzadas. Estos modelos pueden identificar patrones complejos invisibles para humanos y algoritmos tradicionales.",
    imageUrl: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.EPIC
  },
  {
    id: 95,
    title: "Optimización de red con computación cuántica",
    description: "Explora aplicaciones de computación cuántica para problemas de optimización logística. Esta tecnología emergente promete resolver problemas complejos imposibles para computadoras tradicionales.",
    imageUrl: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.EPIC
  },
  {
    id: 96,
    title: "Ecosistema logístico integrado con APIs abiertas",
    description: "Desarrolla un ecosistema logístico con arquitectura de APIs abiertas. Este enfoque permite integraciones flexibles con partners y adaptación rápida a nuevas tecnologías.",
    imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.EPIC
  },
  {
    id: 97,
    title: "Logística espacial para cadenas de suministro globales",
    description: "Explora aplicaciones de tecnología espacial en logística global. Desde comunicaciones satelitales avanzadas hasta potenciales rutas de transporte suborbitales para carga urgente.",
    imageUrl: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.EPIC
  },
  
  // LEGENDARY TIPS (3%)
  {
    id: 98,
    title: "Cadenas de suministro autónomas con IA general",
    description: "Implementa sistemas de IA general para gestión autónoma completa de cadenas de suministro. Estos sistemas pueden comprender contextos complejos y tomar decisiones estratégicas como un experto humano.",
    imageUrl: "https://images.unsplash.com/photo-1581092335397-9583eb92d232?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.LEGENDARY
  },
  {
    id: 99,
    title: "Logística cuántica predictiva",
    description: "Utiliza computación cuántica y algoritmos avanzados para predicciones logísticas de precisión sin precedentes. Esta tecnología revolucionaria puede optimizar cadenas de suministro globales completas.",
    imageUrl: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.LEGENDARY
  },
  {
    id: 100,
    title: "Redes logísticas autoadaptativas",
    description: "Desarrolla redes logísticas completamente autoadaptativas. Estos sistemas evolucionan continuamente, optimizándose en tiempo real ante cualquier cambio sin intervención humana.",
    imageUrl: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600&q=80",
    rarity: TipRarity.LEGENDARY
  }
];